// 16:9(가로형) : 0013_480x270_light.png
// 10:16(세로형/캐치) : 0013_360x578_light.png
export const DISPLAY_THUMBNAIL = {
  VERTICAL: '360x578',
  HORIZONTAL: '480x270',
};
